module.exports = __webpack_public_path__ + "img/MS-J-16.ffd43fe1.svg";